import { PWA_UPDATE_STATUS } from "@/services/pwa-update-status";

import { create } from "zustand";

// Client state only. The logged-in account of each role is server data: it
// lives in the query cache (`sessionQuery` in services/router-session.js).
export const useStore = create((set) => ({
  activeRole: null,
  setActiveRole: (activeRole) =>
    set(() => ({ activeRole: activeRole || null })),

  pwaUpdateStatus: PWA_UPDATE_STATUS.CURRENT,
  pwaOnline: true,
  // True on the first boot after "Mettre à jour": plays the fresh-app animation once.
  pwaFreshStart: false,

  lastAgendaOfferId: "",
  setLastAgendaOfferId: (lastAgendaOfferId) =>
    set(() => ({ lastAgendaOfferId })),
}));
